import { Modal, Card, Box, Button, Icon, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CancelIcon from '../../../icons/cancelIcon.svg';
import logo from '../../../icons/whiteinosio.svg';
import leftSideLargeElipse from '../../../icons/left-side-large-elipse.svg';
import rightSideSmallElipse from '../../../icons/right-side-small-elipse.svg';
import { AcknowledgementV2Dto } from '@inosio/payments-sdk';

const useStyles = makeStyles({
  modalContainer: {
    background: '#FFFFFF',
  },
  titleText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '24px !important',
    lineHeight: '22px !important',
    color: '#14142B !important',
    textAlign: 'center',
  },
  listItem: {
    fontFamily: 'Work Sans',
    fontSize: '18px',
    color: '#000000 !important',
    display: 'list-item !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
  },
  detailsText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    color: '#000000 !important',
  },
  buttonContainer: {
    bottom: '20px',
    width: 'calc( 100% - 32px )',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  modalContent: {
    maxWidth: '615px',
    width: '100%',
    margin: '40px auto 20px auto',
  },
  dateDetailsText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '26px !important',
    lineHeight: '21px !important',
    color: '#000000 !important',
  },
  leftSideLargeEllipse: {
    position: 'absolute',
    left: '0px',
    bottom: '-10px',
  },
  rightSideSmallEllipse: {
    position: 'absolute',
    right: '-15px',
    bottom: '16rem',
  },
});

interface AcknowledgmentModalProps {
  open: boolean;

  /**
   * Callback fired when the user clicks on the close icon or on the backdrop of the modal
   */
  handleDismiss: () => void;

  /**
   * Callback fired when the user clicks on the primary button in the modal
   */
  handleClickButton: () => void;

  /**
   * The acknowledgment that needs to be shown in this modal
   */
  acknowledgmentDto: AcknowledgementV2Dto | null;
}

export default function AcknowledgmentModal(props: AcknowledgmentModalProps) {
  const classes = useStyles();
  const metadata = props.acknowledgmentDto?.Metadata as any;
  const buttonText = metadata?.PrimaryButtonText || '';

  const style = {
    boxShadow: '0px -5px 0px rgba(128, 128, 128, 0.5), 0px 5px 0px rgba(128, 128, 128, 0.5)',
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    minHeight: '615px',
    pointerEvents: 'auto',
    width: '98%',
    maxWidth: '759px',
    borderRadius: '24px',
    outline: 'none',
  };

  const handleButtonClick = () => {
    props.handleClickButton();
    if (!!metadata?.PrimaryButtonUrl) window.open(metadata.PrimaryButtonUrl);
  };

  const handleModalClose = (event: any, reason: string) => {
    if (reason && reason === 'backdropClick') props.handleDismiss();
  };

  return (
    <Box className={classes.modalContainer}>
      <Modal open={props.open} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" onClose={handleModalClose}>
        <Card sx={style}>
          {!props.acknowledgmentDto?.PreventsAppUsage && (
            <Box className={classes.closeButton}>
              <Box>
                <img src={logo} alt="inosio logo" width={50} height={50} />
              </Box>
              <IconButton onClick={props.handleDismiss}>
                <Icon>
                  <img src={CancelIcon} alt="close" width={24} height={24} />
                </Icon>
              </IconButton>
            </Box>
          )}
          <Box className={classes.modalContent}>
            <div className={classes.detailsText} dangerouslySetInnerHTML={{ __html: props.acknowledgmentDto?.RichContent?.replace(/<\/?html>|<\/?body>/g, '') || '' }} />
            <Box className={classes.rightSideSmallEllipse}>
              <img src={rightSideSmallElipse} alt="inosio logo" width={70} height={70} />
            </Box>
          </Box>
          <Box className={classes.buttonContainer}>
            <Button
              variant="contained"
              style={{
                fontFamily: "'Open Sans', sans-serif",
                fontStyle: 'normal',
                fontWeight: 700,
                background: '#39A2DB',
                border: '3px solid #39A2DA',
                borderRadius: '24px',
                textTransform: 'capitalize',
                padding: '2px 35px',
              }}
              onClick={handleButtonClick}
            >
              {buttonText}
            </Button>
            <Box className={classes.leftSideLargeEllipse}>
              <img src={leftSideLargeElipse} alt="inosio logo" width={70} height={70} />
            </Box>
          </Box>
        </Card>
      </Modal>
    </Box>
  );
}
